module.exports = __webpack_public_path__ + "img/jngtitle.d7788c86.png";